// src/components/Exaustores/UnidadesList/UnidadesList.jsx
import React from "react";
import UnidadeItem from "../UnidadeItem/UnidadeItem";
import { sortUnidades } from "../../../utils/utilsExaustor";

/**
 * Lista de unidades de um exaustor
 * @param {Array} unidades - Array de unidades
 * @param {string} exaustorId - ID do exaustor pai
 * @param {Function} onToggleUnidade - Callback para toggle de unidade
 */
const UnidadesList = ({ unidades, exaustorId, onToggleUnidade }) => {
  if (!Array.isArray(unidades) || unidades.length === 0) {
    return <p id="nenhumaUndText">Nenhuma unidade vinculada</p>;
  }

  const sortedUnidades = sortUnidades(unidades);

  return (
    <div className="unidadesCampo">
      {sortedUnidades.map((unidade, index) => (
        <UnidadeItem
          key={`${exaustorId}-${unidade.id}-${index}`}
          unidade={unidade}
          onClick={() => onToggleUnidade(exaustorId, unidade.id)}
        />
      ))}
    </div>
  );
};

export default UnidadesList;